import { ControllerRenderProps } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { getCampaign } from "@/sideEffects/api";
import React from "react";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { AppMultiSelect } from "@/components/ui/app-multi-select";
import { TargetIcon } from "lucide-react";

export const PlayerCampaignSelect: React.FC<{
  field: ControllerRenderProps<any>;
  colorScheme?: 'blue' | 'purple' | 'green' | 'amber' | 'default';
}> = ({ field, colorScheme = 'default' }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const { data: campaignData, isLoading: isCampaignLoading } = useQuery({
    queryFn: () =>
      getCampaign({ pageNumber: 1, numberOfObjectsPerPage: 999999 }, { Firm_Id: String(activeFirm?.firmGuid) }),
    queryKey: ["getCampaign"],
  });

  const options = (campaignData?.data?.result || []).map((r) => ({
    value: r.intId,
    label: r.name,
    icon: <TargetIcon className="h-4 w-4" />
  }));

  const isLoading = isCampaignLoading;

  return (
    <AppMultiSelect
      value={field.value}
      onChange={field.onChange}
      options={options}
      isLoading={isLoading}
      placeholder={t("entities.campaign")}
      label={t("entities.campaign")}
      colorScheme={colorScheme}
    />
  );
};
